import * as React from 'react';

import './style.scss';

const Loader = () => {
  return(
    <section className='loader'>
      <div className='sk-double-bounce'>
        <div className='sk-child sk-double-bounce-1' />
        <div className='sk-child sk-double-bounce-2' />
      </div>
    </section>
  );
};

export default Loader;
